import { render } from "./IllustrationCard.vue?vue&type=template&id=0aa5e464&scoped=true"
import script from "./IllustrationCard.vue?vue&type=script&lang=js"
export * from "./IllustrationCard.vue?vue&type=script&lang=js"

import "./IllustrationCard.vue?vue&type=style&index=0&id=0aa5e464&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa5e464"]])

export default __exports__